import React from "react";
import "./FilterBar.css"; // optional if you want to style it

const FilterBar = ({ selectedPlatform, onPlatformChange }) => {
  const platforms = ["Amazon", "Flipkart", "D2C"];

  return (
    <div className="filter-bar">
      <label className="filter-label">Platform:</label>
      <select
        className="filter-select"
        value={selectedPlatform}
        onChange={(e) => onPlatformChange(e.target.value)}
      >
        <option value="">All</option>
        {platforms.map((platform) => (
          <option key={platform} value={platform}>
            {platform}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterBar;
